export * from './customer/default/focus';

export const SCALE_FOCUSED = 1.05;

/**
 * The focus border is a `rect` carrying a shader, so it keeps a texture at all times and Lightning keeps
 * submitting its quad even while the stroke is fully transparent — ElementCore only skips an element whose
 * render alpha is zero, it never looks at the colour alpha. Driving the alpha instead lets the quad, and the
 * shader program switch that comes with it, be dropped for every unfocused tile.
 *
 * The hide is delayed past the stroke colour fade-out so the transition itself stays untouched.
 */
export const BORDER_HIDE_DELAY = 0.25;

export const FOCUSED_BORDER_ALPHA = [1, { duration: 0 }];

export const UNFOCUSED_BORDER_ALPHA = [0, { duration: 0, delay: BORDER_HIDE_DELAY }];
